import React from "react";
import { Box, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";
import { app_title, s3StaticImagePath } from "../config";
import styles from "../styles/PrivacyPolicy.module.css";

function MFTermsCondition() {
  return (
    <Box sx={{ overflow: "auto", padding: 5 }}>
      <Helmet>
        <title>Muthoot Finance Privacy Policy {app_title && `| ${app_title}`}</title>
      </Helmet>
      <div style={{ maxWidth: "240px", margin: "0 auto", marginBottom: "20px" }}>
        <img
          src={`${s3StaticImagePath}/1756979958-kqlxrxH0E9.webp`}
          alt="lender_logo"
          style={{ width: '100%' }}
        />
      </div>
      <Typography gutterBottom variant="h4" align="center" fontWeight="500">
        Terms and Conditions
      </Typography>
      <p style={{ textAlign: "center", maxWidth: "600px", margin: "0 auto", marginBottom: "20px" }}>This Terms & conditions to be read in conjunction with the Master Terms & Conditions and
        shall apply and fully binding on the Borrower(s)
        <br />
        <br />
        PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY
      </p>

      <div id={styles.content}>
        <blockquote>
          <p>
            <h3>
              <strong>1. Overview</strong>
            </h3>
          </p>
        </blockquote>

        <blockquote>
          <p>
            1.1. These Terms and Conditions (“Terms”) governs your (“you”, “your”, or “User”) usage of
            the Platform as well as all other linked web pages, pages, images, features, and mobile
            applications (“Platform”) offered from time to time by Muthoot Fincorp Limited (“Muthoot
            Fincorp” , “we”, “us”) either through itself or a third party. These terms shall be read in
            conjunction with the Master Terms & Conditions, privacy policy, loan documents and all other
            policies governing the Platform.
          </p>
          <p>
            1.2. By clicking the ‘Checkbox’ button above, you hereby agree and acknowledge that you
            are at least eighteen years old and above, and have read, understood and consent to being
            governed and bound by these Terms. These Terms constitute a binding and enforceable
            contract between you and the Company. If you do not understand these Terms, or do not
            accept or agree to any part of them, then you are requested to not access the Platform.
          </p>
          <p>
            1.3. These Terms are an electronic record in terms of the Information Technology Act 2000,
            and rules made thereunder, time, and other applicable laws that require publishing of
            policies for collection, usage, storage, disclosure and transfer of information. This electronic
            record is generated by a computer system and does not require any physical or digital
          </p>
        </blockquote>

        <blockquote>
          <p>
            <h3>
              <strong>2. Representations and Warranties</strong>
            </h3>
          </p>
        </blockquote>

        <blockquote>
          <p>
            2.1. You represent and warrant that you are legally entitled to enter this Platform and you
            are of legal age as per applicable laws in your jurisdiction to enter into an enforceable
            contract with us.
          </p>
          <p>
            2.2. You agree to use the services available to you through the Platform only for purposes
            that are permitted by (a) these Terms: and (b) any applicable law, regulation or generally
            accepted practices or guidelines in the relevant jurisdictions.
          </p>
          <p>
            2.3. You declare that all the particulars and information provided by you are true, correct,
            complete and up-to-date in all respects and that you have not withheld any information
            whatsoever. You also undertake to keep Muthoot Fincorp Limited updated of any change in
            the information provided by you.
          </p>
          <p>
            2.4. You confirm that you have/had no insolvency proceedings against you, nor have you
            ever been adjudicated insolvent by any court or other authority, and further confirm that you
            have read the information on various loan products made available by Muthoot Fincorp
            Limited on <a href="https://www.muthootfincorp.com" target="_blank" style={{ color: "black", textDecoration: "underline" }}>https://www.muthootfincorp.com</a>.
          </p>
          <p>
            2.5. You understand and acknowledge that Muthoot Fincorp Limited shall have the absolute
            discretion, without assigning any reason to reject your loan application and that Muthoot
            Fincorp Limited shall not be responsible/liable in any manner whatsoever for such rejection
          </p>
        </blockquote>

        <blockquote>
          <p>
            <h3>
              <strong>3. Collection of Information</strong>
            </h3>
          </p>
        </blockquote>

        <blockquote>
          <p>
            3.1. We shall collect any SMS information for facilitating you any lending services and nonlending service including such purposes as may be required by Muthoot Fincorp Limited or
            as per applicable law
          </p>
          <p>
            3.2. You further authorize the Company to use above mentioned information for Udyam
            registration and/or to share the same with any credit rating agency, to get information related
            to my/our credit history as part of loan sanctioning process.
          </p>
          <p>
            3.3. You authorize Muthoot Fincorp Limited to collect/store/verify any and all
            information/details received through the Live image based verification or the video-based
            customer identification process (“Video KYC”) including but not limited to the video
            verification call itself, information received from documents/information captured/shared
            through the video verification call.
          </p>
          <p>
            3.4. You accept and agree that you are providing "your express consent” to us to collect,
            receive, obtain, and/or fetch on your behalf, a copy of your credit information report from
            credit information companies at any time. You agree to execute such authorization/ consent
            in such format as may be requested by Muthoot Fincorp Limited from time to time for such
            request
          </p>
        </blockquote>

        <blockquote>
          <p>
            <h3>
              <strong>4. Information Disclosure</strong>
            </h3>
          </p>
        </blockquote>

        <blockquote>
          <p>
            4.1. All types of your information shall be handled by Muthoot Fincorp Limited with your
            express consent as per its privacy policy. We may share your Information as part of our data
            disclosures to third parties on a need to know basis with your prior and explicit consent. This
            disclosure may be required for us to check your eligibility for, providing you access to, and
            enable fulfilment of any services being provided to you, or to comply with any legal
            obligations, to enforce user agreements, to facilitate any marketing and advertising activities,
            to fetch a copy of your credit information report from credit information companies or to
            prevent, detect, mitigate, and investigate fraudulent or illegal activities related to any
            services being provided to you.
          </p>
          <p>
            4.2. If you believe that any information in your credit information report is inaccurate, you
            may dispute the same by directly contacting the concerned credit information company
            through its website.
          </p>
          <p>
            4.3. We may disclose user information to third parties such as business partners, law
            enforcement agencies, insurers, regulatory, government organisations and service providers.
            Such disclosure may be required for us to provide you access to our products and services;
            for enhancing your experience; for providing feedback on products; to comply with our legal
            obligations and court orders; to conduct market research or surveys; to enforce these Terms,
            to facilitate our marketing and advertising activities; to analyze data; for customer service
            assistance; to prevent, detect, mitigate, and investigate fraudulent or illegal activities related
            to our product and services. We do not disclose our User’s information to third parties for
            marketing and advertising purposes without your explicit consent.
          </p>
          <p>
            4.4. We may disclose your information if required to do so by law or in the good faith belief
            that such disclosure is reasonably necessary to respond to court orders or other legal
            process. We may disclose user information to law enforcement agencies, third party rights
            owners, or others in the good faith belief that such disclosure is reasonably necessary to:
            enforce the Terms; respond to claims that any content that may violates the rights of a third
            party; or protect the rights, property or personal safety of our users or the general public.
          </p>
          <p>
            4.5. In case you wish to withdraw your consent to contact you, or for the continued
            collection, use or disclosure of information, restrict disclosure to third parties, or any other
            consent already granted to us at any time, please e-mail us at <a href="mailto:customercare@muthoot.com" style={{ color: "black", textDecoration: "underline" }}>customercare@muthoot.com</a>{" "}
            or contact us at 1800 102 1616 / 0471 4911560. Please note that this could impede or
            restrict our ability to provide our services to you. Further, if you have availed any facility from
            Muthoot Fincorp Limited, Muthoot Fincorp Limited shall have the right to continue processing
            your information till such facility has been repaid in full, along with any interest and dues
            payable and/or for such period as may be allowed under applicable law.
          </p>
          <p>
            4.6. I authorize Muthoot Fincorp Limited to exchange, share all information and details as
            provided by me and in relation to my existing loans and/or repayment history to any third
            party including but not limited to its group companies, service providers, banks, financial
            institutions, credit bureaus, telecommunication companies, statutory bodies, business
            partners etc. for customer verification, personalization of products or services, credit rating,
            data enrichment, marketing or promotion of Muthoot Fincorp Limited or related products or
            that of its associates/business partners and affiliates or for enforcement of your obligations
            and I shall not hold Muthoot Fincorp Limited (or any of its group companies or its/their
            agents/representatives/ business partners) liable for the use/sharing of the information as
            stated above.
          </p>
        </blockquote>

        <blockquote>
          <p>
            <h3>
              <strong>5. Video KYC</strong>
            </h3>
          </p>
        </blockquote>
        <blockquote>
          <p>
            5.1. You expressly consent Muthoot Fincorp Limited to collect/store/verify any and all
            information/details received through Video KYC process including but not limited to the video
            call itself, information received from documents/information captured/shared through the
            video verification call.
          </p>
          <p>
            5.2 Muthoot Fincorp Limited to collect, manage and store your Video KYC information in
            accordance with the Reserve Bank of India (Know Your Customer (KYC)) Directions, 2016.
          </p>
          <p>
            5.3. In case, the documents shown and verified by Muthoot Fincorp Limited over a video
            verification call do not comply with Muthoot Fincorp policies and / or relevant guidelines due
            to any reason whatsoever, your application request for Video KYC shall be rejected.
          </p>
          <p>
            5.4. You shall ensure that internet connection is suitable for Video KYC Process.
          </p>
          <p>
            5.5. You shall possess requisite documents and materials as required for Video KYC
            process to avoid any inconvenience.
          </p>
          <p>
            5.6. On opting for Video KYC process, a video call shall be initiated between you and
            Muthoot Fincorp Limited to initiate the Video KYC process.
          </p>
          <p>
            5.7. You shall be required to verify your identity by answering certain questions asked by
            Muthoot Fincorp Limited representative through a video call.
          </p>
        </blockquote>

        <blockquote>
          <p>
            <h3>
              <strong>6. Unified Payments Interface (“UPI")</strong>
            </h3>
          </p>
        </blockquote>
        <blockquote>
          <p>
            6.1. When you register and transact on the Platform using your UPI address, you agree to
            ensure the following:
          </p>

          <blockquote>
            <p>
              6.1.1. You are solely responsible for linking your correct bank account.
            </p>
            <p>
              6.1.2. You are solely responsible to keep Your One Time Password (“OTP”), UPI PIN and
              bank account related details confidential. Sharing such information with others may lead to
              unauthorized usage, for which the Platform shall not be responsible
            </p>
            <p>
              6.1.3. You shall take full responsibility of the payment request that you make and authorize
              on the Platform through your UPI address, including addition of beneficiary, typing and
              reviewing virtual payments address
            </p>
            <p>
              6.1.4. You agree that Muthoot Fincorp Limited shall not be liable for any delay in the
              completion of the funds transfer or any loss on account of error in the execution of the funds
              transfer by you.
            </p>
            <p>
              6.1.5. You are required to ensure availability of sufficient funds in your UPI linked Bank
              Account(s) in order to avoid transaction declines and charges if any accessed by your issuer
              Bank
            </p>
          </blockquote>

          <p>
            6.2. Charges
          </p>

          <blockquote>
            <p>
              6.2.1. Muthoot Fincorp Limited does not charge its Users any fee for accessing the
              Platform, however, we reserve the right to change our fee policy from time to time.
            </p>
          </blockquote>
        </blockquote>

        <blockquote>
          <p>
            <h3>
              <strong>7. Communication through SMS and other third-party messaging applications</strong>
            </h3>
          </p>
        </blockquote>

        <blockquote>
          <p>
            You expressly that Muthoot Fincorp Limited may contact you and communicate with you
            over telephonic calls, by email, through whatsApp or SMS on the mobile number mentioned
            herein, or through any other communication mode (“Communication Modes”) to verify the
            details provided by you. Further, you confirm that you would like to know through the abovementioned lCommunication Modes about various Muthoot Fincorp Limited loan offer
            schemes or loan promotional schemes or any other promotional schemes relating to various
            products/services offered by Muthoot Fincorp Limited /its group companies/business
            partners from time to time and hereby authorize Muthoot Fincorp Limited, its group
            companies, employees, agents, associates, business partners to contact you from time to
            time for the same.
          </p>
        </blockquote>

        <blockquote>
          <p>
            <h3>
              <strong>8. Contact information and customer care</strong>
            </h3>
          </p>
        </blockquote>

        <blockquote>
          <p>
            Email us at: <a href="mailto:customercare@muthoot.com" style={{ color: "black", textDecoration: "underline" }}>customercare@muthoot.com</a>
          </p>
          <p>
            Contact us at: 1800 102 1616 / 0471 4911560
          </p>
        </blockquote>
      </div>
    </Box >
  );
}

export default MFTermsCondition;
